
import Model from '../core/Model';

class TagModel extends Model {
  constructor(props) {
    super(props);

    this.memberName = 'Tag';
    super.generateNomenclature();
    this.resourceRoute= '/tags';

    this.schema = {
      id: {key: 'id', type: 'text', label: 'Id', tag: 'id'},
      key: {key: 'key', type: 'text', label: 'Key', tag: 'key'},
      name: {key: 'name', type: 'text', label: 'Name', tag: 'name'},
      path: {key: 'path', type: 'text', label: 'Path', tag: 'path'}
    }
    this.nameKey = "name";
  }

  children(opts) {
    const url = this.buildUrl(this.getResourceUrlBase() + '/' + opts.tagId + '/children.json', opts.params);

    return $.ajax({
      type: 'GET',
      url: url
    })
    .done((data, status) => {
      opts.done(data);
    })
    .fail((jqXHR, status) => {
      opts.fail(status);
    });
  }
}

export default TagModel;
